import { CheckrReportStatus } from "@src/appV2/Accounts/Documents/types";

import { type CheckrApplicationStatusResponse } from "./useGetCheckrApplicationStatus";

const isCheckrApplicationStatusPending = (
  checkrApplicationStatus: CheckrApplicationStatusResponse["data"]
) => {
  return (
    !checkrApplicationStatus.reportStatus ||
    checkrApplicationStatus.reportStatus === CheckrReportStatus.PENDING
  );
};

export { isCheckrApplicationStatusPending };
